import Quill, { QuillOptionsStatic } from "quill";
import Delta from "quill-delta";
import { getLogger, StringUtil, ModelRow } from "@mcleod/core";
import { DataSourceMode } from "../../databinding/DataSource";
import { StyledEditorPropDefinitions, StyledEditorProps } from "./StyledEditorProps";
import { Panel } from "../panel/Panel";
import { ComponentTypes } from "../../base/ComponentTypes";
import { ComponentPropDefinitions } from "../../base/ComponentProps";

const log = getLogger("component.StyledEditor");

export class StyledEditor extends Panel {
  content: Panel;
  _quillParent: HTMLElement;
  quill: Quill;
  toolbar: Panel;

  constructor(props?: Partial<StyledEditorProps>) {
    super(props);
    this.toolbar = new Panel({id: "toolbar", fillRow: true});
    this.content = new Panel({id:"quillParent", fillRow: true, fillHeight: true});
    this._quillParent = document.createElement("div");
    this.content._element.appendChild(this._quillParent)
    this.add(this.toolbar, this.content);

    const toolbarOptions = [
      [{ 'font': [] }],
      [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      [{ 'align': [] }],
      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      ['blockquote', 'code-block'],
    ];
    const options: QuillOptionsStatic = {
      placeholder: "Enter the comment text...",
      modules: {
        toolbar: toolbarOptions,
      },
      theme: "snow",
    };
    this.quill = new Quill(this._quillParent, options);
    this.setProps(props);
  }

  override displayData(data: ModelRow, allData: ModelRow[], rowIndex: number) {
    if (data == null)
      this.quill.setContents(null);
    else if (this.field != null) {
      const value = data.get(this.field);
      log.debug("displayData", this, data, value);
      if (StringUtil.isEmptyString(value))
        this.quill.setText("");
      else {
        if (value.startsWith("{\"ops\":"))
          this.quill.setContents(new Delta(JSON.parse(value)));
        else
          this.quill.setText(value);
      }
    }
  }

  public override updateBoundData(row: ModelRow, mode: DataSourceMode) {
    if (mode !== DataSourceMode.SEARCH && this.field != null) {
      const delta = this.quill.getContents();
      row.set(this.field, JSON.stringify(delta), this);
    }
  }

  override _serializeNonProps():string {
    return "";
  }

  override getPropertyDefinitions(): ComponentPropDefinitions {
    return StyledEditorPropDefinitions.getDefinitions();
  }

  override get serializationName() {
    return "stylededitor";
  }
}

ComponentTypes.registerComponentType("stylededitor", StyledEditor.prototype.constructor);
